<template>
  <div id="contenedor-listado-expedientes-catalogo-documentos-desktop">
    <v-data-table
    :headers="headers"
    :items="listadoExpedienteCatalogoDocumentos"
    :items-per-page="itemsPerPage">
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip
        v-if="mixValidaScopesActions(2)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip
        v-if="mixValidaScopesActions(3)"
        top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.etapa`]="{ item }">
        <span>{{setEtapa(item.etapa)}}</span>
      </template>
      <template v-slot:[`item.seRepite`]="{ item }">
        <v-icon
          v-if="item.seRepite"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="grey">
            mdi-close-thick
          </v-icon>
      </template>
      <template v-slot:[`item.esObra`]="{ item }">
        <v-icon
          v-if="item.esObra"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
      </template>
      <template v-slot:[`item.esServicio`]="{ item }">
        <v-icon
          v-if="item.esServicio"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
      </template>
      <template v-slot:[`item.esLicitacionPublica`]="{ item }">
        <v-icon
          v-if="item.esLicitacionPublica"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
      </template>
      <template v-slot:[`item.esLicitacionSimplificada`]="{ item }">
        <v-icon
          v-if="item.esLicitacionSimplificada"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
      </template>
      <template v-slot:[`item.esAdjudicacionDirecta`]="{ item }">
        <v-icon
          v-if="item.esAdjudicacionDirecta"
          color="green">
            mdi-check-bold
          </v-icon>
          <v-icon
          v-else
          color="red">
            mdi-close-thick
          </v-icon>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoExpedientesCatalogoDocumentosDesktop',
  props: {
    listadoExpedienteCatalogoDocumentos: {
      type: Array,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  data() {
    return {
      itemsPerPage: -1,
      headers: [
        {
          text: 'Descripción',
          align: 'start',
          value: 'descripcion',
        },
        { text: 'Módulo', value: 'modulo' },
        { text: 'Etapa', width: '90', value: 'etapa' },
        { text: 'Normatividad', value: 'normatividad' },
        {
          text: '¿Se Repite?', align: 'center', width: '60', value: 'seRepite', sortable: false,
        },
        {
          text: 'Obra', align: 'center', width: '60', value: 'esObra', sortable: false,
        },
        {
          text: 'Servicio', align: 'center', width: '60', value: 'esServicio', sortable: false,
        },
        {
          text: 'LP', align: 'center', width: '60', value: 'esLicitacionPublica', sortable: false,
        },
        {
          text: 'LS', align: 'center', width: '60', value: 'esLicitacionSimplificada', sortable: false,
        },
        {
          text: 'AD', align: 'center', width: '60', value: 'esAdjudicacionDirecta', sortable: false,
        },
        {
          text: '', width: '120', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    setEtapa(etapa) {
      if (etapa === 1) return 'AE';
      if (etapa === 2) return 'EJ';
      if (etapa === 3) return 'DE';
      return 'N/A';
    },
    editar(expedienteCatalogoDocumento) {
      eventBus.$emit('editar-expediente-catalogo-documento', expedienteCatalogoDocumento);
    },
    borrar(expedienteCatalogoDocumento) {
      eventBus.$emit('eliminar-expediente-catalogo-documento', expedienteCatalogoDocumento);
    },
  },
};
</script>

<style lang="scss">
</style>
